// extracted by mini-css-extract-plugin
module.exports = {"box":"TextCallToAction_box__lrarF","transparent":"TextCallToAction_transparent__3tznc","link":"TextCallToAction_link__tGhHL","icon":"TextCallToAction_icon__3_VFS"};